import { useMemo } from "react";
import Roles from "../../../../models/roles";
import { useAppSelector as useSelector } from "../../../../store";
import {
  TSortOrder,
  TTimesheetSort,
  TTimesheetVariant,
} from "../../../../store/timesheet/types";
import Sort from "../../../UI/Icons/Sort";

const TableHeader = ({
  variant = "client-pending",
  sortBy,
  sortOrder,
  onSortChange,
}: {
  variant: TTimesheetVariant;
  sortBy: TTimesheetSort;
  sortOrder: TSortOrder;
  onSortChange: (field: TTimesheetSort) => void;
}) => {
  const [role, type] = variant.split("-") as [
    "client" | "admin",
    "pending" | "approval" | "history"
  ];
  const isHistory = type === "history";

  const user = useSelector((state) => state.auth.user)
  
    const isAdmin = useMemo(() => user?.role.name === Roles.SUPER_ADMIN || user?.role.name === Roles.GENERAL_ADMIN, [user])

  return (
    <div className="d-none d-lg-flex gap-20 py-10px px-15px border-top border-bottom border-off-white fs-13 fw-700 text-black">
      <div className="flex-grow-1 d-flex gap-20">
        <div className="min-w-50px"></div>
        { (variant === "admin-approval") ?
          <div
            className="flex-grow-1 min-w-230px low-min-w-150px d-flex gap-5 align-items-center cursor-pointer"
            onClick={() => onSortChange("centre")}
          >
            Centre
            <Sort active={sortBy === "centre"} direction={sortOrder} />
          </div> : 
          <div
            className="min-w-230px low-min-w-150px d-flex gap-5 align-items-center cursor-pointer"
            onClick={() => onSortChange("first_name")}
          >
            {role === "admin" ? "Employee" : "Candidate"}
            <Sort active={sortBy === "first_name"} direction={sortOrder} />
          </div>
        }
        <div className="min-w-50px"></div>
        <div className="flex-grow-1 d-flex gap-20">
          { (variant === "admin-approval") ?
            <div
              className="flex-grow-1 min-w-230px low-min-w-150px d-flex gap-5 align-items-center cursor-pointer"
              onClick={() => onSortChange("first_name")}
            >
              {role === "admin" ? "Employee" : "Candidate"}
              <Sort active={sortBy === "first_name"} direction={sortOrder} />
            </div> : 
            <div
              className="flex-grow-1 min-w-230px low-min-w-150px d-flex gap-5 align-items-center cursor-pointer"
              onClick={() => onSortChange("centre")}
            >
              {(variant === "client-approval" || variant === "client-pending") ? "Vacancy" : "Centre"}
              <Sort active={sortBy === "centre"} direction={sortOrder} />
            </div>
          }
          <div
            className={`${
              variant === "client-approval"
                ? "min-w-210px low-min-w-120px"
                : "min-w-250px"
            } d-flex gap-5 align-items-center  cursor-pointer low-min-w-150px`}
            onClick={() => onSortChange("time_frame")}
          >
            Job Timeframe
            <Sort active={sortBy === "time_frame"} direction={sortOrder} />
          </div>
          {variant === "client-approval" && <div className="min-w-120px"></div>}
          {isAdmin && variant !== "admin-history" && variant !== "admin-payroll-pending" ? <div className="min-w-120px">Pay Rate</div> : "" }
          {isAdmin && (variant === "admin-pending" || variant === "admin-payroll-pending") ? <div className="min-w-120px  cursor-pointer"  onClick={() => onSortChange("timesheet_status")}>Status <Sort active={sortBy === "timesheet_status"} direction={sortOrder} /></div> : "" }
          {isAdmin && (variant === "admin-history") ? <div className="min-w-120px low-min-w-120px cursor-pointer" onClick={() => onSortChange("sent_to_payroll_on")}>Status <Sort active={sortBy === "sent_to_payroll_on"} direction={sortOrder} /></div> : "" }
          {/* {isAdmin && (variant === "admin-history" || variant === "admin-pending") ? <div className="min-w-120px" onClick={() => onSortChange("status")}>Status <Sort active={sortBy === "status"} direction={sortOrder} /></div> : "" } */}
          
        </div>
      </div>
      <div
        className={
          isHistory || variant === "admin-approval"
            ? "min-w-110px"
            : "min-w-130px"
        }
      ></div>
    </div>
  );
};

export default TableHeader;
